import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface ClientErrorTranslations {
    retryableHeadline: string;
    terminalHeadline: string;
    connectivityIntro: string;
    connectivityRetryTipPrefix: string;
    connectivityRetryTipSuffix: string;
    connectivityDesktopTip: string;
    connectivityContactTip: string;
    terminalAccessMessage: string;
    retry: string;
}

const ENGLISH_TRANSLATIONS: ClientErrorTranslations = {
    retryableHeadline: "We're having trouble loading your form",
    terminalHeadline: "We couldn't access your form",
    connectivityIntro:
        'A weak or unstable connection - especially on mobile devices - can sometimes interrupt loading. These steps usually help:',
    connectivityRetryTipPrefix:
        'Make sure you have a strong Wi-Fi or stable internet connection, then tap ',
    connectivityRetryTipSuffix: '.',
    connectivityDesktopTip:
        "If it still doesn't work, try opening this link on a desktop or laptop.",
    connectivityContactTip: 'If the problem persists, contact your law firm for help.',
    terminalAccessMessage:
        'If you believe you should have access to this form, contact your law firm for assistance.',
    retry: 'Retry',
};

const FRENCH_TRANSLATIONS: ClientErrorTranslations = {
    retryableHeadline: 'Nous avons de la difficulté à charger votre formulaire',
    terminalHeadline: 'Nous n’avons pas pu accéder à votre formulaire',
    connectivityIntro:
        'Une connexion faible ou instable — surtout sur un appareil mobile — peut parfois interrompre le chargement. Ces étapes aident généralement :',
    connectivityRetryTipPrefix:
        'Assurez-vous d’avoir une connexion Wi-Fi solide ou une connexion Internet stable, puis appuyez sur ',
    connectivityRetryTipSuffix: '.',
    connectivityDesktopTip:
        'Si cela ne fonctionne toujours pas, essayez d’ouvrir ce lien sur un ordinateur de bureau ou un portable.',
    connectivityContactTip:
        'Si le problème persiste, communiquez avec votre cabinet d’avocats pour obtenir de l’aide.',
    terminalAccessMessage:
        'Si vous croyez devoir avoir accès à ce formulaire, communiquez avec votre cabinet d’avocats pour obtenir de l’aide.',
    retry: 'Réessayer',
};

export const CLIENT_ERROR_TRANSLATIONS: Record<TemplateFormLanguage, ClientErrorTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getClientErrorTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): ClientErrorTranslations {
    return CLIENT_ERROR_TRANSLATIONS[language] ?? CLIENT_ERROR_TRANSLATIONS.en;
}
